import { Trash2 } from 'lucide-react';
import React from 'react';
import { MRT_Row, MRT_TableInstance } from '@talentmesh/table';
import { Button } from '@/Components/shadcn/button';
import { CandidateRowEntry } from '@/Models/CandidateRowEntry';
import { cn } from '@/lib/utils';
import { useInviteCandidateContext } from '../../Contexts/InviteCandidateContext';

interface CandidateRowProps {
    row: MRT_Row<CandidateRowEntry>;
    table: MRT_TableInstance<CandidateRowEntry>;
}

const CandidateRowEntryDeleteButton = ({ row, table }: CandidateRowProps): React.JSX.Element | undefined => {
    const { deleteCandidateAsync } = useInviteCandidateContext();
    const candidate = row.original;

    const handleDelete = async (): Promise<void> => {
        await deleteCandidateAsync(candidate);
        table.resetRowSelection();
    };

    if (candidate.isReadOnly) {
        return undefined;
    }

    return (
        <div className="flex w-full flex-row justify-end">
            <Button
                type="button"
                variant="ghost"
                size="icon-sm"
                className={cn(
                    'text-destructive hover:bg-destructive/10 hover:text-destructive',
                    !candidate.isReadOnly ? 'visible' : 'pointer-events-none invisible',
                )}
                onClick={handleDelete}
                data-cy="deleteButton"
                aria-label="Delete candidate"
            >
                <Trash2 className="size-5" />
            </Button>
        </div>
    );
};

export default CandidateRowEntryDeleteButton;
